

document.addEventListener('algolia.hooks.initialize', function() {
    algoliaShopify.hooks.registerHook('beforeInstantSearchOptions', function(options) {
      // Modify default options, then return them
      return options;
    });
    algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components, trackSearchAttribution) {
      const _currencyFormatter = new Intl.NumberFormat(Shopify.locale, { style: "currency", currency: Shopify.currency.active });
      const subtitle = hit.meta?.custom?.subtitle != undefined ? hit.meta.custom.subtitle:''
      const hitImage = hit.image ? hit.image : hit.product_image
        return html`
      <product-card
        class="ais-hit ais-product product-card product-card--blends product-card--show-secondary-media bg-custom text-custom"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-variant-id="${hit.objectID}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
        style="--background: 255 255 255; --text-color: 28 28 30; opacity: 1; transform: translateY(0px);"
        onClick="${() => trackSearchAttribution(hit)}"
      >
      <div class="product-card__figure">
      <a href="${algoliaShopify.helpers.instantsearchLink(hit)}" data-instant>
        <img
         width="1500" height="1500" loading="lazy" sizes="(max-width: 699px) calc(100vw / 2 - 40px), (max-width: 1200px) calc(100vw / 3 - 64px), calc((100vw - 96px) / 3 - (24px / 3 * 2))" class="product-card__image ds-product-card__image product-card__image--primary ds-product-card__image--primary  aspect-square"
          src="${hitImage}&width=300"
          alt="${hit.title} - ${hit.title}"
        />
        <img
          width="1500" height="1500" loading="lazy" class="product-card__image ds-product-card__image product-card__image--secondary object-fill" sizes="(max-width: 699px) calc(100vw / 2 - 40px), (max-width: 1200px) calc(100vw / 3 - 64px), calc((100vw - 96px) / 3 - (24px / 3 * 2))"
          src="${hitImage}&width=300"
          alt="${hit.title} - ${hit.title}"
        />
        </a>
        </div>

        <div class="product-card__info ds-product-card__info">
        <div class="ds-product-card__info-content gap-2 w-full">
         <div class="ds-product-card__title-wrapper w-full">
            <p class="product-card__title">
                <a
                data-algolia-index="${hit.index}"
                data-algolia-position="${hit.productPosition}"
                data-algolia-queryid="${hit.queryID}"
                data-algolia-objectid="${hit.objectID}"
                class="bold text-base sm:text-lg"
                href="${algoliaShopify.helpers.instantsearchLink(hit)}"
                title="${algoliaShopify.helpers.fullTitle(
                    hit.title,
                )}"
                >
                ${hit.title}
                </a>
            </p>
          <p
            class="ais-hit--subtitle"
            title="${hit.product_type}${algoliaShopify.translation_helpers.by(
              hit.vendor
            )}"
          >
            ${components.Highlight({ attribute: 'product_type', hit })}
                <span class="ds-product-card__subtitle hidden sm:block text-subdued"> ${subtitle}</span>
            ${hit.vendor && components.Highlight({ attribute: 'vendor', hit })}
          </p>
            </div>
          <price-list class="price-list ds-price-list  ">
            <sale-price class="text-base sm:text-lg semi-bold">${window.themeVariables.strings.search_price_from} ${_currencyFormatter.format((hit.variants_min_price)).replace(/\$/g, "$$$$")}</sale-price>
            ${!hit._distinct &&
              html`
                <span class="ais-hit--price-striked"
                  ><span
                    >${algoliaShopify.helpers.displayStrikedPrice(
                      hit.price,
                      hit.compare_at_price
                    )}</span
                  ></span
                >
              `}
            ${!hit._distinct &&
              html`
                <span class="ais-hit--price-discount"
                  >${algoliaShopify.helpers.displayDiscount(
                    hit.price,
                    hit.compare_at_price,
                    hit.price_ratio
                  )}</span
                >
              `}
          </price-list>
          <!-- Extra info examples - Remove the display: none to show them -->
          <p class="ais-hit--info" style="display: none">
            ${hit.sku &&
              html`
                <span class="algolia-sku"
                  >${components.Highlight({ attribute: 'sku', hit })}</span
                >
              `}
            ${hit.barcode &&
              html`
                <span class="algolia-barcode"
                  >${components.Highlight({ attribute: 'barcode', hit })}</span
                >
              `}
            ${hit.weight &&
              html`
                <span class="algolia-weight">${hit.weight}</span>
              `}
            ${!hit.taxable &&
              html`
                <span class="algolia-taxable"
                  >${algoliaShopify.translations.taxFree}</span
                >
              `}
          </p>
          <!-- Tags example - Remove the display: none to show them -->
          <p class="ais-hit--tags" style="display: none">
            ${hit?._highlightResult.tags?.map(
              tag =>
                html`
                  <span class="ais-hit--tag">${tag.value}</span>
                `
            )}
          </p>
          </div>
        </div>
      </product-card>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {
    return html`
        <div class="ais-page">
          <h1 class="h2 text-center">${algoliaShopify.translations.searchTitle}</h1>
          <div class="ais-input">
            <algolia-search-box class="ais-search-box-container">
            </algolia-search-box>
            <div class="ais-input-button">
              <div class="ais-clear-input-icon"></div>
            </div>
          </div>
          <div class="ais-facets-button">
            Show filters
          </div>
          <div class="ais-facets">
            <div class="ais-clear-refinements-container"></div>
            <div class="ais-current-refined-values-container"></div>
            ${data.facets.map(
              facet =>
                html`
              <details
                  is="accordion-disclosure"
                  id="accordion-filter-p-m-filter-${facet.escapedName}"
                  class="algolia-filter accordion ds-accordion group ${facet.escapedName}"
                >
                <summary>
                 <div class="accordion__toggle ds-accordion__toggle bold">
                     <span class="h6">${facet.title}</span>
                     <span class="chevron group-expanded:rotate">
                        <svg role="presentation" focusable="false" width="13" height="8" class="icon icon-chevron-bottom-custom" viewBox="0 0 13 8">
                            <path d="M10.793 0.292969L6.49997 4.58597L2.20697 0.292969L0.792969 1.70697L6.49997 7.41397L12.207 1.70697L10.793 0.292969Z" fill="currentColor"></path>
                        </svg>
                    </span>
                </div>
                  </summary>
                  <div
                    class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container accordion__content ds-accordion__content"
                  ></div>
                </details>
                  `
            )}
          </div>
          <div class="ais-block">
            <div class="ais-search-header">
              <div class="ais-stats-container"></div>
              <div class="ais-change-display">
                <span class="ais-change-display-block ais-change-display-selected"
                  ><i class="fa fa-th-large"></i
                ></span>
                <span class="ais-change-display-list"
                  ><i class="fa fa-th-list"></i
                ></span>
              </div>
              <div class="ais-sort">
                ${data.multipleSortOrders
                  ? html`
                      ${algoliaShopify.translations.sortBy}
                      <span class="ais-sort-orders-container"></span>
                    `
                  : html`
                      ${algoliaShopify.translations.sortBy}
                      ${algoliaShopify.translations.relevance}
                    `}
              </div>
            </div>
            <div class="ais-hits-container ais-results-as-block">
            </div>
          </div>
          <div class="ais-pagination-container"></div>
        </div>
      `;
    });

    const color_map_html = document.getElementById("algolia-color-map")?.innerHTML
    const color_map = color_map_html ? JSON.parse(color_map_html) : {}
  
    algoliaShopify.hooks.registerHook('beforeInstantSearchFacetParamsOptions', function(params, facet) {
      if (facet.escapedName == "options.farbe") {
        return {
          ...params,
          templates: {
            item(item, { html }) {
              const { url, label, count, isRefined } = item;
              const inputId = `option-value-facets-sidebar-filter-color-${label.toLowerCase()}`;
              const color = color_map[label.toLowerCase()]
              const color_style = color != undefined ? `url(${color});` : `linear-gradient(to right, ${label.toLowerCase()}, ${label.toLowerCase()});`
              return html`
                <label 
                  class="color-swatch rounded-full" 
                  data-tooltip="${label}" 
                  style="--swatch-background: ${color_style}"
                  for="${inputId}"
                >
                  <span class="sr-only">${label}</span>
                </label>
              `;
            },
          },
        }
      }

      return {
        ...params
      }
    });


      algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', function() {
        // Please be aware not all widgets are available
        const { searchBox } = window.algoliaShopify.externals.widgets;
    
        let timerId;
        const timeout = 280;
        const searchBoxWidget = searchBox({
          container: 'algolia-search-box',
          placeholder: 'Search for products',
          queryHook(query, refine) {
            clearTimeout(timerId);
            timerId = setTimeout(() => refine(query), timeout);
          },
        });
    
        return [searchBoxWidget];
      })
});